<template>
  <div class="use-callcenter-filials-list">
    <loader v-if="loading" fixed/>
    <template v-else-if="notEmptyFilialsList">
      <h1 class="mb-2">
        Карта курьеров
      </h1>
      <h3 class="mb-2">
        Выберите филиал
      </h3>
      <v-row>
        <v-col
          v-for="item in filials"
          :key="item.id"
          sm="3"
        >
          <pickup-point
            name="point"
            :value="item.id"
            :item="item"
            @change="openMap(item)"
          />
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <h1 class="mb-10">
        Карта курьеров
      </h1>
      <h3 class="empty-text">
        Нет филиалов работающих с Кол-центром
      </h3>
    </template>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader.vue'
  import _ from 'lodash'
  import FilialDataService from '@/services/api/FilialDataService'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import PickupPoint from '@/components/order-processing/order-components/second-step/PickupPoint.vue'

  export default {
    name: 'UseCallCentersFilialsList',
    components: { PickupPoint, Loader },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        loading: true,
        filials: [],
      }
    },
    computed: {
      notEmptyFilialsList () {
        return !_.isEmpty(this.filials)
      },
    },
    methods: {
      async loadFilials () {
        try {
          this.filials = await FilialDataService.getUseCallCenterItems()
        } catch (err) {
          this.showErrorFromResponse(err)
        }
      },
      openMap (filial) {
        this.$router.push(`/geo/couriers-map?filialId=${filial.id}`)
      },
    },
    async created () {
      await this.loadFilials()
      this.loading = false
    },
  }
</script>

<style scoped lang="less">
.use-callcenter-filials-list {

}
</style>
